import React, { useEffect, useState } from 'react'
import * as routeLink from "../../constants/routeLink";

import TopInfo from "./../../components/TopInfo/index";
import BalanceInfo from "./../../components/BalanceInfo/index";
import Customcard from "./../../components/Customcard/index";
import Customcard2 from "./../../components/Customcard2/index";
import TopLevel from "./../../components/TopLevel/index";
import Modal from "../../components/Modal/index";
import { useSelector } from 'react-redux';
import { formatNumber, rateExchange, upgrade } from '../../services/services';
import Loading from '../../components/Loading';
import { toast } from 'react-toastify';

const Index = (props) => {
  const { apiReducer } = useSelector((state) => state);
  const { user } = apiReducer;
  const [isLoading, setIsLoading] = useState(false);
  const [tabActive, settabActive] = useState(2);
  const [modal2, setModal2] = useState(null);
  const [dataSelec, setDataSelec] = useState({});

//   const priceUp = [
//     1 * rateExchange, 5 * rateExchange, 10 * rateExchange, 20 * rateExchange, 30 * rateExchange, 50 * rateExchange,
//     100 * rateExchange, 200 * rateExchange, 300 * rateExchange, 500 * rateExchange, 1000 * rateExchange, 3000 * rateExchange, 5000 * rateExchange
// ]

  const [dataShop1, setdataShop1] = useState([
    { title: "Crypto Risk Management", _id: 1, price: 1 * rateExchange, description: "Profit per day", hour: "50/h", level: 0 },
    { title: "Crypto Launchpad", _id: 2, price: 5 * rateExchange, description: "Profit per day", hour: "50/h", level: 0 },
    { title: "Fiat Payment", _id: 3, price: 10 * rateExchange, description: "Profit per day", hour: "50/h", level: 0 },
    { title: "NFT Marketplace", _id: 4, price: 20 * rateExchange, description: "Profit per day", hour: "50/h", level: 0 },
    { title: "NFT Collection", _id: 5, price: 30 * rateExchange, description: "Profit per day", hour: "50/h", level: 0 },
    { title: "Budget Planning", _id: 6, price: 50 * rateExchange, description: "Profit per day", hour: "50/h" },
  ]);

  const [dataShop2, setdataShop2] = useState([
    { title: "Staking", _id: 7, price: 100 * rateExchange, description: "Profit per day", hour: "50/h" },
    { title: "Swap", _id: 8, price: 200 * rateExchange, description: "Profit per day", hour: "50/h" },
    { title: "Crypto Grants", _id: 9, price: 300 * rateExchange, description: "Profit per day", hour: "50/h" },
    { title: "Dogx Game", _id: 10, price: 500 * rateExchange, description: "Profit per day", hour: "50/h", level: 0 },
    { title: "Cross Chain Bridge", _id: 11, price: 1000 * rateExchange, description: "Profit per day", hour: "50/h", level: 0 },
    { title: "AI Trader", _id: 12, price: 3000 * rateExchange, description: "Profit per day", hour: "50/h", level: 0 },
    { title: "DeFi Farming", _id: 13, price: 5000 * rateExchange, description: "Profit per day", hour: "50/h", level: 0 },
  ]);


  useEffect(() => {
    if (user.upgrade) {
      for (const key in user.upgrade) {
        if (Object.prototype.hasOwnProperty.call(user.upgrade, key)) {
          const element = user.upgrade[key];
          // console.log(key.replace("t", ""), element);

          updateLevelById(key.replace("t", "") * 1, element);
          updateLevelById1(key.replace("t", "") * 1, element);
        }
      }
      // for (let index = 0; index < user.upgrade.length; index++) {
      //   const element = user.upgrade['t' + index];
      //   console.log(element);

      //   updateLevelById(index + 1, element);
      //   updateLevelById1(index + 1, element);
      // }
    }
  }, [user]);

  const updateLevelById = (id, newLevel) => {
    setdataShop1(prevDataShop1 => {
      const found = prevDataShop1.some(item => item._id === id);

      if (!found) {
        // console.log(`ID ${id} không tồn tại trong mảng.`);
        return prevDataShop1; // Trả về mảng cũ mà không thay đổi gì
      }

      return prevDataShop1.map(item =>
        item._id === id ? { ...item, level: newLevel } : item
      );
    });
  };

  const updateLevelById1 = (id, newLevel) => {
    setdataShop2(prevDataShop1 => {
      const found = prevDataShop1.some(item => item._id === id);

      if (!found) {
        // console.log(`ID ${id} không tồn tại trong mảng.`);
        return prevDataShop1; // Trả về mảng cũ mà không thay đổi gì
      }

      return prevDataShop1.map(item =>
        item._id === id ? { ...item, level: newLevel } : item
      );
    });
  };

  const confirm_upgrade = (vl) => {
    console.log(vl);
    setDataSelec(vl);
    setModal2(true);
  }

  const buy_ = async () => {
    console.log('runnn');

    setIsLoading(true);
    const res = await upgrade(dataSelec._id);
    if (res?.message) {
      toast(res.message)
    }
    setIsLoading(false);
    setModal2(false);
  }
  return (
    <div className='d-flex justify-content-center align-items-center flex-column'>

      <TopInfo />
      <TopLevel />

      <BalanceInfo />

      <div className='w-100 d-flex justify-content-center align-items-center flex-column p-2'>

        <div className='w-100 radius-custom d-flex justify-content-between align-items-center'>
          <button className={`btn card-custom custom-btn tab-btn-item w-50  scale_btn text-white me-2 ${tabActive == 1 ? "active" : ""}`} onClick={() => { settabActive(1) }}> Finance</button>
          <button className={`btn card-custom custom-btn w-50 tab-btn-item  scale_btn text-white  ${tabActive == 2 ? "active" : ""}`} onClick={() => { settabActive(2) }}> Technology</button>

        </div>
      </div>
      <div className='w-100 d-flex justify-content-center align-items-center flex-column px-2'>
        {tabActive == 1 && <>
          {!dataShop1 || dataShop1.length <= 0 && <div className='d-flex flex-column card-custom align-items-center w-100 p-4'>

            <div className=''>
              <img src={`${routeLink.domain}/assets/imgs/hour.png`} className='w-100 h-100 object-fit-cover assdasdsaddsds' />
            </div>
            <span className='text-white '>You don't have  cards</span>
          </div>}
          {dataShop1 && dataShop1.length > 0 && <div className='list w-100 '>
            <ul className='m-0 p-0 list-grid-2'>
              {dataShop1 && dataShop1.map((value, index) => {

                return <li className='mb-2'>
                  <Customcard2 item={value} actions={(value) => confirm_upgrade(value)} />

                </li>
              })}


            </ul>

          </div>}
        </>
        }

        {tabActive == 2 && <>
          {!dataShop2 || dataShop2.length <= 0 && <div className='d-flex flex-column card-custom align-items-center w-100 p-4'>

            <div className=''>
              <img src={`${routeLink.domain}/assets/imgs/hour.png`} className='w-100 h-100 object-fit-cover assdasdsaddsds' />
            </div>
            <span className='text-white '>You don't have  cards</span>
          </div>}
          {dataShop2 && dataShop2.length > 0 && <div className='list w-100 '>
            <ul className='m-0 p-0 list-grid-2'>
              {dataShop2 && dataShop2.map((value, index) => {

                return <li className='mb-2'>
                  <Customcard2 item={value} actions={(value) => confirm_upgrade(value)} />

                </li>
              })}


            </ul>

          </div>}</>}



      </div>
      <div style={{ height: 50 }}></div>
      <Modal setHide={setModal2} show={modal2}>
        <button disabled={isLoading} onClick={() => buy_()} className='d-flex w-50 m-0 m-auto justify-content-center align-items-center  scale_btn btn btn-custom-2' style={{ height: "40px", minHeight: "unset" }}>
          {!isLoading && <span className='text-white fw-bold'>Buy</span>}
          {isLoading && <Loading style={{ width: "20px", height: "20px" }} />}
        </button>
        <div className='w-75 d-flex justify-content-center align-items-center flex-column p-2 m-0 m-auto'>
          <div className='card-icon me-2' style={{ width: "80px", height: "80px" }}>
            <img className='w-100 h-100 object-fit-contain' src={`${routeLink.domain}/assets/imgs/footprintDog.png`} />
          </div>

          <h4 className='text-white text-center fs-extra d-flex m-0 mb-3'>{dataSelec?.title}</h4>
          <span className='text-white text-center'>Profit per day</span>
          <div className='d-flex w-100 align-items-center justify-content-center mb-3'>
            <div className='card-icon me-2 d-flex align-items-center justify-content-center radius-custom-8' style={{ width: "20px", height: "20px" }}>
              <img className='w-100 h-100' src={`${routeLink.domain}/assets/imgs/footprintDog.png`} />
            </div>
            <span className='fw-bold color-sub-pri me-1'>{formatNumber(dataSelec.price * 0.05 * dataSelec.level / 30)}  </span> <span className='fw-bold text-success '>(+{formatNumber(dataSelec.price * 0.05 / 30)})</span>
          </div>
          <h4 className='text-white text-center d-flex m-0'>Cost</h4>
          <div className='d-flex justify-content-center align-items-start flex-column mb-3'>
            <div className='d-flex w-100 justify-content-center align-items-center'>
              <div className='card-icon me-2 radius-custom-8' style={{ width: "30px", height: "30px" }} >
                <img className='w-100 h-100' src={`${routeLink.domain}/assets/imgs/footprintDog.png`} />
              </div>
              <span className='fw-bold fs-extra color-sub-pri '>{formatNumber(dataSelec.price)}</span>
            </div>
          </div>

        </div>

      </Modal>

    </div>
  )
}

export default Index;
